export function localizedField(obj, field, langCode, fallbackLangCode = 'en') {
  if (!obj || !Array.isArray(obj.translations)) return '';
  const match = obj.translations.find(t => t.language_code === langCode);
  if (match?.[field]) return match[field];
  const fallback = obj.translations.find(t => t.language_code === fallbackLangCode);
  return fallback?.[field] || '';
}
